import React from 'react';
export function SectionTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`inline-block relative mb-8 md:mb-12 ${className}`} data-id="element-276">
      {/* Decorative esoteric borders */}
      <div className="absolute -inset-1 bg-gradient-to-r from-gold-dark via-gold-light to-gold-dark opacity-40 blur-sm rounded-sm" data-id="element-277"></div>
      <div className="relative bg-mystic-900 border border-gold/50 px-5 sm:px-8 md:px-12 py-3.5 md:py-5 rounded-sm shadow-[0_0_20px_rgba(109,74,156,0.3)] overflow-hidden" data-id="element-278">
        {/* Subtle inner glow */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-279"></div>
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-violet-accent to-transparent opacity-50" data-id="element-280"></div>

        <h2 className="font-serif text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold-light via-gold to-gold-dark uppercase tracking-wide sm:tracking-widest text-center relative z-10" data-id="element-281">
          {children}
        </h2>
      </div>
      {/* Esoteric corner accents */}
      <div className="absolute -top-2 -left-2 w-4 h-4 border-t-2 border-l-2 border-gold" data-id="element-282"></div>
      <div className="absolute -top-2 -right-2 w-4 h-4 border-t-2 border-r-2 border-gold" data-id="element-283"></div>
      <div className="absolute -bottom-2 -left-2 w-4 h-4 border-b-2 border-l-2 border-gold" data-id="element-284"></div>
      <div className="absolute -bottom-2 -right-2 w-4 h-4 border-b-2 border-r-2 border-gold" data-id="element-285"></div>
    </div>;
}